import {useMobile} from "@hps/hops-react";
import {makeStyles} from "@mui/styles";
import * as Sentry from "@sentry/react";
import React from "react";
import Helmet from "react-helmet";
import {connect} from "react-redux";

import SuspenseGate from "App/SuspenseGate.js";
import AddedToBasketOverlay from "Checkout/AddedToBasketOverlay.js";
import BasketExpirationInterstitial from "Checkout/BasketExpirationInterstitial.js";
import ErrorGate from "Components/ErrorGate.js";
import Flex from "Components/Flex.js";
import useOrg from "Hooks/useOrg.js";
import useOrgTheme from "Hooks/useOrgTheme.js";
import useRaildaysApp from "Hooks/useRaildaysApp.js";
import SeatReservationDialog from "SeatReservation/SeatReservationDialog.js";
import AppService from "Services/AppService.js";

import CookieConsentBanner from "./CookieConsent/CookieConsentBanner.js";
import UiBanners from "./UiBanners.js";
import UiBar from "./UiBar.js";
import UiFooter from "./UiFooter.js";
import UiLoader from "./UiLoader.js";
import UiRouter from "./UiRouter.js";
import UiSuspense from "./UiSuspense.js";


/**
 * UI base
 */
const Ui = ({loading, ready}) => {

	const {isMobile} = useMobile();
	const {org} = useOrg();
	const theme = useOrgTheme();

	const {isBeingRenderedByRaildaysApp} = useRaildaysApp();

	const useStyles = makeStyles(theme => {
		return {
			root: {
				background: theme.palette.background.content
			}
		};
	});

	const classes = useStyles();

	const renderMain = () => {
		return (
			<Sentry.ErrorBoundary fallback={props => <ErrorGate notFullHeight={true} {...props} />}>
				<SuspenseGate>
					<React.Suspense fallback={<UiSuspense />}>
						<Helmet>
							<title>{org?.NameTrade}</title>
							<meta name="description" content={`Welcome to ${org?.NameTrade}!`} />
							<meta name="theme-color" content={(theme?.AccentColour || "#299c39")} />
							<link rel="shortcut icon" type="image/png" href={AppService.getRegistrationFaviconUri()} />
							<link rel="apple-touch-icon" href={AppService.getRegistrationFaviconUri()} />
						</Helmet>
						<UiRouter />
					</React.Suspense>
				</SuspenseGate>
			</Sentry.ErrorBoundary>
		);
	};

	let mainContainerTopMargin = (isMobile ? 8 : 12);
	if (isBeingRenderedByRaildaysApp) mainContainerTopMargin -= (isMobile ? 6 : 8);

	return (
		<Flex gap={(!isMobile ? 2 : 1)}>
			{
				!isBeingRenderedByRaildaysApp &&
					<UiBar />
			}
			<div className={classes.root}>
				<Flex
					alignItems="center"
					mt={mainContainerTopMargin}>
					<UiBanners />
					<CookieConsentBanner />
					{(ready && renderMain())}
					<AddedToBasketOverlay />
					<BasketExpirationInterstitial />
					<SeatReservationDialog />
				</Flex>
			</div>
			<Flex alignItems="center">
				<UiFooter />
			</Flex>
			<UiLoader visible={loading} />
		</Flex>
	);

};

export default connect(({loading}) => ({loading}))(Ui);
